import { render, staticRenderFns } from "./CmgHeaderUserIcon.vue?vue&type=template&id=6e5b739c&scoped=true&lang=pug"
import script from "./cmg-header-user-icon.ts?vue&type=script&lang=ts&external"
export * from "./cmg-header-user-icon.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgHeaderUserIcon.vue?vue&type=style&index=0&id=6e5b739c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5b739c",
  null
  
)

export default component.exports